import { render, staticRenderFns } from "./ResultsTableView.vue?vue&type=template&id=807532dc&scoped=true"
import script from "./ResultsTableView.vue?vue&type=script&lang=js"
export * from "./ResultsTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807532dc",
  null
  
)

export default component.exports